module.exports = __webpack_public_path__ + "img/shehui.c408799a.jpg";